import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { BRAND } from '../constants/brand';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1 max-w-3xl mx-auto px-4 sm:px-6 py-24 md:py-28 w-full">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-brand-violet hover:text-slate-900 mb-10 transition-colors"
        >
          <FiArrowLeft />
          Back to home
        </Link>
        <h1 className="font-display text-4xl font-bold text-slate-900 mb-2">Cookie Policy</h1>
        <p className="text-slate-500 text-sm mb-10">Last updated: {new Date().getFullYear()}</p>

        <div className="prose prose-sm max-w-none text-slate-600 space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">What are cookies</h2>
            <p>
              Cookies are small files stored on your device. We use them to operate the site,
              remember preferences, and understand usage—aligned with our IT solutions and business
              services offering.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">Types we may use</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li>Essential cookies required for security and core functionality.</li>
              <li>Analytics cookies to measure traffic and improve performance.</li>
              <li>Preference cookies where applicable to remember your settings.</li>
            </ul>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">Managing cookies</h2>
            <p>You can control cookies through your browser settings. Blocking some cookies may affect site behavior.</p>
          </section>
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">Contact</h2>
            <p>
              <a href={`mailto:${BRAND.contact.email}`} className="text-brand-violet hover:underline">
                {BRAND.contact.email}
              </a>
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CookiePolicy;
